const shippingModelName: { [key: number]: string } = {
  1: 'receber',
  9: 'receber',
  13: 'receber',
  16: 'receber',
  18: 'retirar',
  23: 'receber',
  25: 'receber',
  26: 'receber',
  28: 'retirar',
  80: 'receber',
};

export const getShippingModelName = (type: number) => shippingModelName[type];
